(function(){
  'use strict';

  // Loader
  window.addEventListener('load',function(){
    setTimeout(function(){
      var l=document.getElementById('page-loader');
      if(l){l.classList.add('done');}
      var hero=document.querySelector('.hero');
      if(hero){hero.classList.add('loaded');}
    },900);
  });

  // Header scroll
  var hdr=document.querySelector('.site-header');
  function updateHdr(){
    if(!hdr)return;
    hdr.classList.toggle('at-top',window.scrollY<10);
  }
  updateHdr();
  window.addEventListener('scroll',updateHdr,{passive:true});

  // Hamburger
  var burger=document.getElementById('hamburger');
  var mobNav=document.getElementById('mobile-nav');
  if(burger&&mobNav){
    burger.addEventListener('click',function(){
      var open=mobNav.classList.toggle('open');
      burger.setAttribute('aria-expanded',open);
      var s=burger.querySelectorAll('span');
      if(open){s[0].style.transform='rotate(45deg) translate(4px,4px)';s[1].style.opacity='0';}
      else{s[0].style.transform='';s[1].style.opacity='';}
    });
  }

  // Cart drawer
  var drawer=document.getElementById('cart-drawer');
  var overlay=document.getElementById('cart-overlay');
  var cartClose=document.getElementById('cart-close');
  var cartOpen=document.getElementById('cart-open');
  var cartBody=document.getElementById('cart-body');
  var cartFoot=document.getElementById('cart-foot');

  function openCart(){
    if(!drawer)return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    fetchCart();
  }
  window.icOpenCart=openCart;
  function closeCart(){
    if(!drawer)return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
  }
  if(cartOpen)cartOpen.addEventListener('click',openCart);
  if(cartClose)cartClose.addEventListener('click',closeCart);
  if(overlay)overlay.addEventListener('click',closeCart);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart();});

  function money(cents){return(cents/100).toFixed(2).replace('.',',')+'$';}

  function fetchCart(){
    if(!cartBody)return;
    fetch('/cart.js').then(function(r){return r.json();}).then(renderCart).catch(function(){
      if(cartBody)cartBody.innerHTML='<p style="color:var(--fog);text-align:center;padding:40px">Erreur de chargement.</p>';
    });
  }

  function renderCart(cart){
    if(!cartBody)return;
    if(cart.item_count===0){
      cartBody.innerHTML='<div style="text-align:center;padding:56px 20px"><p style="color:var(--fog);font-size:.9rem;margin-bottom:24px">ton panier est vide.</p><a href="/collections/all" style="font-family:var(--font-display);font-size:12px;font-weight:800;letter-spacing:.15em;text-transform:uppercase;color:var(--white);border-bottom:1px solid rgba(245,245,245,.3);padding-bottom:2px">découvrir la boutique →</a></div>';
      if(cartFoot)cartFoot.innerHTML='';
      return;
    }
    var h='';
    cart.items.forEach(function(item){
      var img=item.image?'<img src="'+item.image+'" alt="'+item.title+'" style="width:100%;height:100%;object-fit:cover">':'<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:var(--black-3);font-size:1.5rem;color:rgba(245,245,245,.06)">⚜</div>';
      h+='<div style="display:grid;grid-template-columns:72px 1fr;gap:14px;padding:18px 0;border-bottom:1px solid var(--line)">';
      h+='<div style="aspect-ratio:3/3.8;overflow:hidden;background:var(--black-3)">'+img+'</div>';
      h+='<div>';
      h+='<p style="font-family:var(--font-display);font-size:.88rem;font-weight:800;letter-spacing:.04em;text-transform:lowercase;color:var(--white);margin-bottom:4px">'+item.title+'</p>';
      if(item.variant_title&&item.variant_title!=='Default Title'){h+='<p style="font-size:.74rem;color:var(--fog);margin-bottom:10px">'+item.variant_title+'</p>';}
      h+='<div style="display:flex;align-items:center;justify-content:space-between">';
      h+='<span style="font-family:var(--font-display);font-size:.88rem;font-weight:700;color:var(--white)">'+money(item.final_line_price)+'</span>';
      h+='<button onclick="icRemove(\''+item.key+'\')" style="font-family:var(--font-display);font-size:9px;letter-spacing:.12em;text-transform:uppercase;color:var(--fog);background:none;border:none;cursor:pointer;transition:color .2s" onmouseover="this.style.color=\'var(--white)\'" onmouseout="this.style.color=\'var(--fog)\'">retirer</button>';
      h+='</div></div></div>';
    });
    cartBody.innerHTML=h;

    var fh='';
    fh+='<div class="drawer-shipping-note">Livraison calculée à la caisse.</div>';
    fh+='<div style="display:flex;justify-content:space-between;font-size:.875rem;color:var(--fog);margin-bottom:14px"><span>total</span><span style="color:var(--white);font-weight:700">'+money(cart.total_price)+'</span></div>';
    fh+='<a href="/checkout" class="drawer-checkout-premium">passer à la caisse →</a>';
    fh+='<div class="drawer-trust"><span>livraison calculée à la caisse</span><span>paiement sécurisé</span><span>échanges faciles</span></div>';
    if(cartFoot)cartFoot.innerHTML=fh;
    renderCartRecommendation(cart);
  }

  function renderCartRecommendation(cart){
    if(!cartBody || !cart || !cart.items || cart.items.length===0)return;
    // Keep the recommendation focused on reaching the 2- or 3-item bundle tier.
    if(cart.item_count>=3)return;

    fetch('/collections/all/products.json?limit=12')
      .then(function(r){return r.json();})
      .then(function(data){
        var owned={};
        cart.items.forEach(function(i){owned[String(i.product_id)]=1;});
        var product=(data.products||[]).find(function(p){return !owned[String(p.id)] && p.variants && p.variants.some(function(v){return v.available;});});
        if(!product)return;

        var variant=product.variants.find(function(v){return v.available;});
        if(!variant)return;
        var img=(product.images&&product.images[0])?product.images[0].src:'';
        var rec=document.createElement('div');
        rec.className='cart-rec';
        rec.innerHTML=
          '<div class="cart-rec__eyebrow">DÉBLOQUE TON OFFRE</div>'+
          '<div class="cart-rec__row">'+
            (img?'<img class="cart-rec__img" src="'+img+'" alt="">':'')+
            '<div class="cart-rec__copy"><strong>'+product.title.toLowerCase()+'</strong><span>'+money(Number(variant.price)*100)+'</span></div>'+
            '<a class="cart-rec__view" href="/products/'+product.handle+'">VOIR →</a>'+
          '</div>'+
          '<div class="cart-rec__note cart-rec__note--strong">2 TEES = 89$ CAD · 3 TEES = 119$ CAD</div>';
        cartBody.appendChild(rec);
      }).catch(function(){});
  }

  window.icRemove=function(key){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
      .then(function(r){return r.json();})
      .then(function(cart){renderCart(cart);updateBadge(cart.item_count);});
  };

  function updateBadge(n){
    var b=document.getElementById('cart-badge');
    if(b){b.textContent=n;b.style.display=n>0?'flex':'none';}
  }

  // ATC
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-atc]');
    if(!btn)return;
    var id=btn.getAttribute('data-atc');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){return r.json();})
      .then(function(){return fetch('/cart.js');})
      .then(function(r){return r.json();})
      .then(function(cart){updateBadge(cart.item_count);openCart();});
  });

  // Reveal on scroll
  var revEls=document.querySelectorAll('.reveal');
  if(revEls.length){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('on');obs.unobserve(en.target);}});
    },{threshold:.08,rootMargin:'0px 0px -30px 0px'});
    revEls.forEach(function(el){obs.observe(el);});
  }

  // Gallery thumb
  window.switchImg=function(btn,src){
    var img=document.getElementById('main-img');
    if(img)img.src=src;
    document.querySelectorAll('.gallery-thumb').forEach(function(t){t.classList.remove('active');});
    btn.classList.add('active');
  };

  // Qty
  window.adjQty=function(d){
    var i=document.getElementById('pdp-qty');
    if(!i)return;
    var v=parseInt(i.value)+d;
    if(v>=1)i.value=v;
  };

})();

// Email form success state
var emailForm = document.getElementById('email-form');
if(emailForm){
  emailForm.addEventListener('submit',function(e){
    var btn = emailForm.querySelector('.email-btn');
    if(btn){
      setTimeout(function(){
        btn.textContent='✓ INSCRIT';
        btn.style.background='var(--silver)';
      },400);
    }
  });
}

// Grain animation on hero
var heroGrain = document.querySelector('.hero__grain');
var gt = 0;
if(heroGrain){
  (function grainTick(){
    gt = (gt+1)%3;
    heroGrain.style.backgroundPosition = gt+'px '+gt+'px';
    requestAnimationFrame(grainTick);
  })();
}

// Subtle parallax on hero
var heroImg = document.querySelector('.hero__img');
if(heroImg && window.innerWidth > 768){
  window.addEventListener('scroll',function(){
    var scroll = window.scrollY;
    heroImg.style.transform = 'scale(1.04) translateY('+(scroll*0.06)+'px)';
  },{passive:true});
}






// ─────────────────────────────────────
// COUNTDOWN 24H ROLLING
// ─────────────────────────────────────
(function(){
  function pad(n){ return n < 10 ? '0'+n : String(n); }

  // 24h rolling: resets at midnight local time
  function tick(){
    var now = new Date();
    var midnight = new Date(now);
    midnight.setHours(24,0,0,0);
    var diff = midnight.getTime() - now.getTime();

    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);

    var eh = document.getElementById('cd-hours');
    var em = document.getElementById('cd-mins');
    var es = document.getElementById('cd-secs');
    if(eh) eh.textContent = pad(h);
    if(em) em.textContent = pad(m);
    if(es) es.textContent = pad(s);
  }
  tick();
  setInterval(tick, 1000);
})();

// ─────────────────────────────────────
// STICKY HEADER SCROLL CLASS
// ─────────────────────────────────────
(function(){
  var hdr = document.querySelector('.site-header');
  if(!hdr) return;
  window.addEventListener('scroll', function(){
    hdr.classList.toggle('scrolled', window.scrollY > 40);
  }, {passive:true});
})();

// ─────────────────────────────────────
// STICKY ATC BAR — apparaît après 600px
// ─────────────────────────────────────
(function(){
  var bar = document.getElementById('sticky-atc');
  if(!bar) return;
  var shown = false;
  window.addEventListener('scroll', function(){
    var should = window.scrollY > 600;
    if(should !== shown){
      shown = should;
      bar.classList.toggle('visible', shown);
    }
  }, {passive:true});
})();

// ─────────────────────────────────────
// HERO SCARCITY — injecter badge
// ─────────────────────────────────────
(function(){
})();

// ─────────────────────────────────────
// ACHETER MAINTENANT — redirect direct vers checkout
// ─────────────────────────────────────
(function(){
  var btn = document.getElementById('pdp-buy-now');
  if(!btn) return;

  btn.addEventListener('click', function(){
    var form = document.getElementById('pdp-form');
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;

    if(!variantInput) {
      window.location.href = '/checkout';
      return;
    }

    var variantId = variantInput.value;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    // Redirect via form POST vers /cart/add — checkout immédiat
    var tempForm = document.createElement('form');
    tempForm.method = 'POST';
    tempForm.action = '/cart/add';

    var fId = document.createElement('input');
    fId.type = 'hidden'; fId.name = 'id'; fId.value = variantId;
    tempForm.appendChild(fId);

    var fQty = document.createElement('input');
    fQty.type = 'hidden'; fQty.name = 'quantity'; fQty.value = qty;
    tempForm.appendChild(fQty);

    var fReturn = document.createElement('input');
    fReturn.type = 'hidden'; fReturn.name = 'return_to'; fReturn.value = '/checkout';
    tempForm.appendChild(fReturn);

    document.body.appendChild(tempForm);
    tempForm.submit();
  });
})();


// ─────────────────────────────────────
// HERO CTA ANALYTICS — explicit instrumentation
// ─────────────────────────────────────
(function(){
  var cta = document.getElementById('hero-shop-cta');
  if(!cta) return;

  // Make sure nothing intercepts the CTA tap.
  cta.style.pointerEvents = 'auto';

  cta.addEventListener('click', function(){
    var payload = {
      event: 'hero_shop_cta_click',
      label: 'DÉCOUVRIR LE DROP 03',
      destination: cta.getAttribute('href'),
      page: window.location.pathname,
      ts: Date.now()
    };

    // Google Tag Manager / GA setups using dataLayer.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    // Shopify Web Pixels / Customer Events when publish is available.
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('hero_shop_cta_click', payload);
      }
    } catch(e) {}

    // Generic listener for heatmap/custom analytics integrations.
    try {
      window.dispatchEvent(new CustomEvent('icitte:hero_cta_click', { detail: payload }));
    } catch(e) {}
  }, { passive: true });
})();

// CONVERSION COMPLETION V4 ANALYTICS
(function(){function p(n,d){d=d||{};d.event=n;d.page=location.pathname;window.dataLayer=window.dataLayer||[];window.dataLayer.push(d);try{if(window.Shopify&&Shopify.analytics&&typeof Shopify.analytics.publish==="function")Shopify.analytics.publish(n,d)}catch(e){}}
document.addEventListener("click",function(e){var x=e.target.closest("[data-analytics]");if(x)p(x.dataset.analytics,{label:(x.innerText||"").trim(),destination:x.getAttribute("href")||"",product_title:x.dataset.productTitle||"",product_id:x.dataset.productId||""})});
var seen={};if("IntersectionObserver"in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var k=e.target.id||e.target.dataset.analytics||e.target.className;if(!seen[k]){seen[k]=1;p("element_impression",{element:k})}io.unobserve(e.target)}})},{threshold:.45});document.querySelectorAll("#hero-shop-cta,.product-card,[data-analytics^=promo_],.section-see-all").forEach(function(x){io.observe(x)})}
var ds={};function dep(){var m=Math.max(1,document.documentElement.scrollHeight-innerHeight),q=Math.min(100,Math.round(scrollY/m*100));[25,50,75,100].forEach(function(d){if(q>=d&&!ds[d]){ds[d]=1;p("scroll_depth",{depth:d})}})}addEventListener("scroll",dep,{passive:true});dep();
var st=document.getElementById("mobile-shop-sticky"),fp=document.getElementById("featured-products");function ss(){if(!st||!fp||innerWidth>640){if(st)st.classList.remove("is-visible");return}st.classList.toggle("is-visible",fp.getBoundingClientRect().bottom<=innerHeight*.92)}addEventListener("scroll",ss,{passive:true});addEventListener("resize",ss);ss()})();

// CONVERSION V5 — quick add + funnel instrumentation
(function(){
 function emit(n,d){d=d||{};d.event=n;d.page=location.pathname;window.dataLayer=window.dataLayer||[];window.dataLayer.push(d);try{if(window.Shopify&&Shopify.analytics&&typeof Shopify.analytics.publish==='function')Shopify.analytics.publish(n,d)}catch(e){}}
 document.addEventListener('click',function(e){var b=e.target.closest('[data-quick-add]');if(!b)return;e.preventDefault();e.stopPropagation();var id=b.dataset.quickAdd;b.disabled=true;emit('quick_add_click',{product_title:b.dataset.productTitle,variant_title:b.dataset.variantTitle,variant_id:id});fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})}).then(function(r){if(!r.ok)throw new Error();return r.json()}).then(function(item){b.classList.add('is-added');b.textContent='✓';emit('add_to_cart',{product_title:b.dataset.productTitle,variant_title:b.dataset.variantTitle,variant_id:id});return fetch('/cart.js')}).then(function(r){return r.json()}).then(function(c){var badge=document.getElementById('cart-badge');if(badge){badge.textContent=c.item_count;badge.style.display='flex'}if(window.icOpenCart)window.icOpenCart()}).catch(function(){b.textContent='!'}).finally(function(){b.disabled=false})},true);
 if(location.pathname.indexOf('/products/')===0)emit('product_view',{path:location.pathname});
 document.addEventListener('click',function(e){if(e.target.closest('a[href="/checkout"],.drawer-checkout-premium'))emit('checkout_click',{})});
})();

